import { defineMessages } from 'react-intl'

export default defineMessages({
  collect: {
    id: 'components.Button.collect',
    defaultMessage: 'Collect Your Cash Gift',
    description: '领红包'
  },
  downloadPayBy: {
    id: 'components.Button.downloadPayBy',
    defaultMessage: 'Download PayBy',
    description: '下载PayBy'
  },
  download: {
    id: 'components.Button.download',
    defaultMessage: 'DOWNLOAD',
    description: '下载PayBy'
  },
  send: {
    id: 'components.Button.send',
    defaultMessage: 'Send',
    description: '发送'
  },
  take: {
    id: 'components.Button.take',
    defaultMessage: 'Take Me to the App',
    description: '下载'
  },
  downloadApp: {
    id: 'components.Button.downloadApp',
    defaultMessage: 'Download APP Now',
    description: '下载'
  },
  downloadLower: {
    id: 'components.Button.downloadLower',
    defaultMessage: 'Download',
    description: '下载'
  },
  goToApp: {
    id: 'components.Button.goToApp',
    defaultMessage: 'Go to the APP',
    description: '下载'
  }
})
